import {  QUERY_GET_WORKSHOP_APPOINTMENT_TEMPLATES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getWorkshopAppointmentTemplates = baseThunk("workshopAppointmentTemplates/workshopAppointmentTemplates", QUERY_GET_WORKSHOP_APPOINTMENT_TEMPLATES, "GET")